import React from 'react';
import { GetStartedWithOtherPortalPage } from 'src/components/Onboarding/GetStartedWithOtherPortalPage';

function action(context: { portalConfig: { viewMode: string } }) {
  const isInternalUser = context.portalConfig.viewMode === 'internal';
  return {
    chunks: ['onboarding-users'],
    ...(isInternalUser
      ? {
          description:
            'Create a new workspace using one of your existing Copilot accounts or create one using a new email.',
          title: 'Copilot • Workspaces',
        }
      : {}),
    component: <GetStartedWithOtherPortalPage />,
  };
}

export default action;
